export default __webpack_public_path__ + "static/media/waves.e8f3f2ad.svg";